{
	"main": {
		"titleMotorna": "Powered",
		"titleJadralna": "Glider",
		"nazaj": "Back"
	},
	"nav": {
		"jadralna": "Glider Billing",
		"motorna": "Powered Billing"
	},
	"labels": {
		"datumOd": "Date FROM:",
		"datumDo": "Date TO:",
		"klubL": "Select aircraft club:",
		"klubP": "Select pilot club:",
		"namen": "Select purpose:",
		"naloga": "Select task:",
		"pilot": "Select pilot:",
		"reg": "Select aircraft registration:",
		"stPristankov": "Number of landings:",
		"stLetov": "Number of flights:",
		"casVZraku": "Time in air:"
	},
	"data": {
		"title": "Data",
		"stPristankov": "No. of landings:",
		"stLetov": "No. of flights:",
		"casVZraku": "Duration:"
	},
	"buttons": {
		"csv": "Export to CSV",
		"natisni": "Print",
		"poslji": "Send",
		"brisiIzbiro": "Clear selection",
		"brisiZapis": "Delete record"
	},
	"table": {
		"reg": "REG",
		"vzlet": "TAKEOFF",
		"pilot": "PILOT",
		"trajanje": "DURATION",
		"naloga": "TASK",
		"datum": "DATE",
		"pristanek": "LANDING",
		"titleU": "List of ultralight flights"
	},
	"modal": {
		"reg": "registration:",
		"vlecno": "towplane:",
		"pilot": "pilot:",
		"instruktor": "instructor:",
		"namen": "purpose:",
		"naloga": "task:",
		"krajV": "takeoff location:",
		"krajP": "landing location:",
		"casV": "takeoff time:",
		"casP": "landing time:",
		"casL": "flight time:",
		"stPristankov": "number of landings:",
		"ifr": "ifr:",
		"nocno": "night:",
		"vizuelno": "visual:",
		"opomba": "note:",
		"datumL": "flight date:",
		"datumV": "entry date:"
	}
}